// src/components/ProtectedRoute.js
import React, { useContext, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { checkAuth, isAuthenticated } = useContext(AuthContext);
    const token = localStorage.getItem('a5srf4wer7w1cd');
    const location = useLocation();

    useEffect(() => {
        checkAuth();
    }, [location]);

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
